<div class="admin-panel-reports">
  <h1 class="mb-4">Raporty</h1>

  <div class="wide">
    <div class="advanced-filters-card mb-4">
      <div class="filters-container">
        <div class="advanced-filters-title">Filtrowanie zaawansowane</div>
        <div class="filters-row">
          <div class="filters-col filters-col-sm-4">
            <span class="reports-filter-label" id="requestTypeLabel"
              >Nazwa wniosku</span
            >
            <p-multiSelect
              ariaLabelledBy="requestTypeLabel"
              (onChange)="
                onMultiSelectFilterChange($event.value, 'rodzajWnioskuCode')
              "
              [options]="applicationTypeOptions"
              [showClear]="true"
              [showToggleAll]="true"
              [(ngModel)]="tableFilters.rodzajWnioskuCode"
              [panelStyle]="{ minWidth: '300px', maxWidth: '500px' }"
              panelStyleClass="custom-application-type-multiselect"
              optionLabel="label"
              optionValue="value"
              placeholder="Wybierz rodzaj wniosku"
              appendTo="body"
              class="w-full"
              display="chip"
              selectedItemsLabel="Wybrano {0} elementów"
              [maxSelectedLabels]="3"
              filter
            ></p-multiSelect>
          </div>
          <div class="filters-col filters-col-sm-4">
            <span class="reports-filter-label" id="comparisonCycleLabel"
              >Cykl porównawczy</span
            >
            <p-select
              ariaLabelledBy="comparisonCycleLabel"
              (onChange)="onPrimeFilterChange($event.value, 'cykl')"
              [options]="comparisonCycleOptions"
              [showClear]="true"
              [(ngModel)]="tableFilters.cykl"
              optionLabel="label"
              optionValue="value"
              placeholder="Wybierz cykl porównawczy"
              appendTo="body"
              class="w-full"
            ></p-select>
          </div>
          <div class="filters-col filters-col-sm-4 filters-actions">
            <p-button
              type="button"
              label="Wyczyść filtry"
              styleClass="customInfoButton outlined"
              (click)="clearFilters()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="wide">
    <p-table
      #table
      (onSort)="onPrimeSortChange($event)"
      [lazy]="true"
      [loading]="isDataLoading()"
      [rows]="tablePage()?.size || 10"
      [scrollable]="true"
      scrollHeight="flex"
      [tableStyle]="{ 'min-width': '60rem' }"
      [totalRecords]="tablePage()?.totalElements || 0"
      [value]="rows()"
      dataKey="id"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="nazwa" class="w-72 min-w-72 max-w-72">
            <div class="flex items-center gap-2">
              Nazwa
              <p-sortIcon field="nazwa" />
            </div>
          </th>
          <th pSortableColumn="dataUtworzenia" class="w-46 min-w-46 max-w-46">
            <div class="flex items-center gap-2">
              Data utworzenia
              <p-sortIcon field="dataUtworzenia" />
            </div>
          </th>
          <th pSortableColumn="status">
            <div class="flex items-center gap-2">
              Status
              <p-sortIcon field="status" />
            </div>
          </th>
          <th pSortableColumn="dataWygenerowania" class="w-55 min-w-55 max-w-55">
            <div class="flex items-center gap-2">
              Data wygenerowania
              <p-sortIcon field="dataWygenerowania" />
            </div>
          </th>
          <th pSortableColumn="wygenerowal">
            <div class="flex items-center gap-2">
              Wygenerował
              <p-sortIcon field="wygenerowal" />
            </div>
          </th>
          <th alignFrozen="right" pFrozenColumn>Akcje</th>
        </tr>
        <tr>
          <td class="table-filter-cell w-72 min-w-72 max-w-72">
            <p-select
              (onChange)="onPrimeFilterChange($event.value, 'nazwa')"
              [options]="reportNameOptions"
              [showClear]="true"
              [(ngModel)]="tableFilters.name"
              optionLabel="label"
              optionValue="value"
              placeholder="Wybierz wartość"
              appendTo="body"
              class="w-full"
              ariaLabel="Filtruj po nazwie raportu"
            ></p-select>
          </td>
          <td class="table-filter-cell w-46 min-w-46 max-w-46">
            <p-date-picker
              (onClear)="onPrimeFilterChange($event, 'dataUtworzenia')"
              (onSelect)="onPrimeFilterChange($event, 'dataUtworzenia')"
              [readonlyInput]="true"
              [showClear]="true"
              [(ngModel)]="tableFilters.createdAt"
              appendTo="body"
              class="w-full customDatePicker"
              dateFormat="dd-mm-yy"
              ariaLabel="Filtruj po dacie utworzenia"
            />
          </td>
          <td class="table-filter-cell">
            <p-select
              (onChange)="onPrimeFilterChange($event.value, 'status')"
              [options]="reportStatusOptions"
              [showClear]="true"
              [(ngModel)]="tableFilters.status"
              optionLabel="label"
              optionValue="value"
              placeholder="Wybierz wartość"
              appendTo="body"
              class="w-full"
              ariaLabel="Filtruj po statusie"
            ></p-select>
          </td>
          <td class="table-filter-cell w-50 min-w-50 max-w-50">
            <p-date-picker
              (onClear)="onPrimeFilterChange($event, 'dataWygenerowania')"
              (onSelect)="onPrimeFilterChange($event, 'dataWygenerowania')"
              [readonlyInput]="true"
              [showClear]="true"
              [(ngModel)]="tableFilters.generatedAt"
              appendTo="body"
              class="w-full customDatePicker"
              dateFormat="dd-mm-yy"
              ariaLabel="Filtruj po dacie wygenerowania"
            />
          </td>
          <td class="table-filter-cell">
            <input
              (change)="onPrimeFilterChange($event.target, 'wygenerowal')"
              aria-label="Filtruj po użytkowniku"
              pInputText
              class="w-full"
              [(ngModel)]="tableFilters.createdBy"
            />
          </td>
          <td alignFrozen="right" pFrozenColumn></td>
        </tr>
      </ng-template>
      <ng-template #body let-report>
        <tr>
          <td class="w-72 min-w-72 max-w-72">
            {{ report.nazwa.label }}
          </td>
          <td class="w-46 min-w-46 max-w-46">
            {{ report.dataUtworzenia | date: 'yyyy-MM-dd HH:mm' }}
          </td>
          <td>
            <span [ngClass]="report.status | statusBadgeClass">
              {{ report.status.label }}
            </span>
          </td>
          <td class="w-55 min-w-55 max-w-55">
            {{
              report.dataWygenerowania
                ? (report.dataWygenerowania | date: 'yyyy-MM-dd HH:mm')
                : '-'
            }}
          </td>
          <td>{{ getReportAuthor(report) }}</td>
          <td alignFrozen="right" pFrozenColumn class="h-16 align-middle">
            <div class="flex items-center h-full justify-end">
              <p-button
                type="button"
                (click)="showParameters(report)"
                ariaLabel="Pokaż parametry"
                pTooltip="Pokaż parametry"
                tooltipPosition="top"
                [rounded]="true"
                [text]="true"
              >
                <i class="pi pi-eye icon" aria-hidden="true"></i>
              </p-button>
              <p-button
                type="button"
                (click)="downloadReport(report)"
                ariaLabel="Pobierz raport"
                pTooltip="Pobierz raport"
                tooltipPosition="top"
                [rounded]="true"
                [text]="true"
                [disabled]="!isDownloadAvailable(report)"
              >
                <i class="pi pi-download icon" aria-hidden="true"></i>
              </p-button>
              <p-button
                type="button"
                (click)="onDeleteReportBtnClick(report)"
                ariaLabel="Usuń raport"
                pTooltip="Usuń"
                tooltipPosition="top"
                [rounded]="true"
                [text]="true"
              >
                <app-icon [name]="'trash'"></app-icon>
              </p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="6">Brak danych</td>
        </tr>
      </ng-template>
    </p-table>
    <div class="table-footer">
      <p-button
        type="button"
        aria-label="Wygeneruj nowy raport"
        label="Wygeneruj nowy raport"
        styleClass="customInfoButton"
        [text]="true"
        (click)="generateReport()"
      />
      <div class="table-pagination">
        <p-paginator
          (onPageChange)="onPrimePageChange($event)"
          [rowsPerPageOptions]="[10, 25, 50]"
          [rows]="tablePage()?.size || 10"
          [totalRecords]="tablePage()?.totalElements || 0"
          pageLinkSize="3"
          styleClass="customPrimePaginator"
        />
        <div class="table-meta">
          Strona {{ (tablePage()?.number || 0) + 1 }} z
          {{ tablePage()?.totalPages || 0 }}
        </div>
      </div>
    </div>
  </div>

  <div class="narrow">
    <div class="advanced-filters-card mb-4">
      <div class="advanced-filters-title">Filtrowanie zaawansowane</div>
      <div class="table-filters-grid">
        <div class="table-filters-field">
          <span class="reports-filter-label" id="requestTypeMobileLabel"
            >Nazwa wniosku</span
          >
          <p-multiSelect
            ariaLabelledBy="requestTypeMobileLabel"
            (onChange)="
              onMultiSelectFilterChange($event.value, 'rodzajWnioskuCode')
            "
            [options]="applicationTypeOptions"
            [showClear]="true"
            [showToggleAll]="true"
            [(ngModel)]="tableFilters.rodzajWnioskuCode"
            optionLabel="label"
            optionValue="value"
            placeholder="Wybierz rodzaj wniosku"
            appendTo="body"
            class="w-full"
            display="chip"
            selectedItemsLabel="Wybrano {0} elementów"
            [maxSelectedLabels]="3"
            filter
          ></p-multiSelect>
        </div>
        <div class="table-filters-field">
          <span class="reports-filter-label" id="comparisonCycleMobileLabel"
            >Cykl porównawczy</span
          >
          <p-select
            ariaLabelledBy="comparisonCycleMobileLabel"
            (onChange)="onPrimeFilterChange($event.value, 'cykl')"
            [options]="comparisonCycleOptions"
            [showClear]="true"
            [(ngModel)]="tableFilters.cykl"
            optionLabel="label"
            optionValue="value"
            placeholder="Wybierz cykl porównawczy"
            appendTo="body"
            class="w-full"
          ></p-select>
        </div>
        <div class="table-filters-field">
          <span class="font-bold" id="reportNameFilterLabel">Nazwa</span>
          <input
            (change)="onPrimeFilterChange($event.target, 'nazwa')"
            pInputText
            class="w-full"
            aria-labelledby="reportNameFilterLabel"
            [(ngModel)]="tableFilters.name"
          />
        </div>
        <div class="table-filters-field">
          <span class="font-bold" id="reportCreatedAtFilterLabel"
            >Data utworzenia</span
          >
          <p-date-picker
            (onClear)="onPrimeFilterChange($event, 'dataUtworzenia')"
            (onSelect)="onPrimeFilterChange($event, 'dataUtworzenia')"
            [readonlyInput]="true"
            [showClear]="true"
            [showIcon]="true"
            [iconDisplay]="'input'"
            [(ngModel)]="tableFilters.createdAt"
            appendTo="body"
            class="w-full customDatePicker"
            dateFormat="dd-mm-yy"
            ariaLabelledBy="reportCreatedAtFilterLabel"
          />
        </div>
        <div class="table-filters-field">
          <span class="font-bold" id="reportStatusFilterLabel">Status</span>
          <p-select
            (onChange)="onPrimeFilterChange($event.value, 'status')"
            [options]="reportStatusOptions"
            [showClear]="true"
            [(ngModel)]="tableFilters.status"
            optionLabel="label"
            optionValue="value"
            placeholder="Wybierz wartość"
            appendTo="body"
            class="w-full"
            ariaLabelledBy="reportStatusFilterLabel"
          ></p-select>
        </div>
        <div class="table-filters-field">
          <span class="font-bold" id="reportGeneratedAtFilterLabel"
            >Data wygenerowania</span
          >
          <p-date-picker
            (onClear)="onPrimeFilterChange($event, 'dataWygenerowania')"
            (onSelect)="onPrimeFilterChange($event, 'dataWygenerowania')"
            [readonlyInput]="true"
            [showClear]="true"
            [showIcon]="true"
            [iconDisplay]="'input'"
            [(ngModel)]="tableFilters.generatedAt"
            appendTo="body"
            class="w-full customDatePicker"
            dateFormat="dd-mm-yy"
            ariaLabelledBy="reportGeneratedAtFilterLabel"
          />
        </div>
        <div class="table-filters-field">
          <span class="font-bold" id="reportCreatedByFilterLabel"
            >Wygenerował</span
          >
          <input
            (change)="onPrimeFilterChange($event.target, 'wygenerowal')"
            pInputText
            class="w-full"
            aria-labelledby="reportCreatedByFilterLabel"
            [(ngModel)]="tableFilters.createdBy"
          />
        </div>
      </div>
      <div class="filters-actions">
        <p-button
          type="button"
          label="Wyczyść filtry"
          styleClass="customInfoButton outlined"
          (click)="clearFilters()"
        />
      </div>
    </div>

    <div class="flex flex-col gap-10">
      @for (report of rows(); track report.id) {
        <p-card>
          <div class="flex flex-col">
            <app-preview-data-wrapper
              label="Nazwa"
              [data]="report.nazwa.key | enumLabel: reportNameLabels"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Data utworzenia"
              [data]="report.dataUtworzenia"
              [dataType]="PreviewDataType.DATE"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Status"
              [data]="report.status.label"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Data wygenerowania"
              [data]="report.dataWygenerowania"
              [dataType]="PreviewDataType.DATE"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>
            <hr class="limiter" />
            <app-preview-data-wrapper
              label="Wygenerował"
              [data]="getReportAuthor(report)"
              additionalCssClasses="font-bold"
            ></app-preview-data-wrapper>

            <div class="flex justify-end gap-4 mt-5">
              <p-button
                label="Pokaż parametry"
                styleClass="customInfoButton outlined"
                (click)="showParameters(report)"
              />
              <p-button
                label="Pobierz raport"
                styleClass="customInfoButton outlined"
                [disabled]="!isDownloadAvailable(report)"
                (click)="downloadReport(report)"
              />
              <p-button
                label="Usuń"
                styleClass="customInfoButton outlined"
                (click)="onDeleteReportBtnClick(report)"
              />
            </div>
          </div>
        </p-card>
      }

      @if (!rows().length && !isDataLoading()) {
        <p-card>
          <div>Brak danych</div>
        </p-card>
      }
    </div>
    <p-paginator
      (onPageChange)="onPrimePageChange($event)"
      [rowsPerPageOptions]="[10, 25, 50]"
      [rows]="tablePage()?.size || 10"
      [totalRecords]="tablePage()?.totalElements"
      pageLinkSize="3"
    />
    <div class="flex justify-between mt-5">
      <div class="table-meta">
        <span>
          Strona {{ (tablePage()?.number || 0) + 1 }} z
          {{ tablePage()?.totalPages || 0 }}
        </span>
        <span>Rekordów na stronie: {{ tablePage()?.size || 0 }}</span>
      </div>
      <p-button
        type="button"
        aria-label="Wygeneruj nowy raport"
        [text]="true"
        label="Wygeneruj nowy raport"
        styleClass="customInfoButton"
        (click)="generateReport()"
      />
    </div>
  </div>
</div>
